// AdsAreScheduledToRunBeforeMinimumApprovalWindow - checks the start date, and returns true if it's before
// the minimum approval window. 
// Given the start date + closest active day of the week + closest active hour
// - if the start date is in the clear, no need to display the message, return false
// - if basis office hours are still open for at least 3 hours, then return true if ads are scheduled to run within 3 hours
// - if basis office hours are closed (or less than 3 hours remaining), then return true if ads are scheduled to run within 3 hours of the start of
//  the next basis office hours
function AdsAreScheduledToRunBeforeMinimumApprovalWindow(budgetAndSchedule) {
  const localTime = new Date()
  const currentESTDateString = localTime.toLocaleString('en-US', {
    timeZone: 'America/New_York',
  })
  const currentLocalHour = localTime.getHours()
  const localCurrentDayOfWeek = localTime.getDay()
  const currentBasisDate = new Date(currentESTDateString)
  const basisCurrentDayOfWeek = currentBasisDate.getDay()
  const basisCurrentHour = currentBasisDate.getHours()
  const basisOfficeStartHour = 10
  const basisOfficeEndHour = 18
  const basisOfficeHoursRemainingToday = basisOfficeEndHour - basisCurrentHour
  const [startYear, startMonth, startDay] = budgetAndSchedule.StartDate.split('-')
  const localTimeOffsetMs = localTime.getTimezoneOffset() * 60 * 1000
  const startTimeAsDate = new Date(Date.UTC(startYear, startMonth - 1, startDay) + localTimeOffsetMs)
  let daysUntilFirstAdActiveDay = (startTimeAsDate - localTime)/1000/60/60/24
  if (daysUntilFirstAdActiveDay < 0) { // immediate start
    daysUntilFirstAdActiveDay = 0
  }
  // if the start date is well in the clear, then we don't need to check anything else
  switch (localCurrentDayOfWeek) {
    case 5: // Friday
      if (daysUntilFirstAdActiveDay >= 3.5) {
        return false
      }
      break
    case 6: // Saturday
      if (daysUntilFirstAdActiveDay >= 2.5) {
        return false
      }
      break
    default: // Sunday - Thursday
      if (daysUntilFirstAdActiveDay >= 1.5) {
        return false
      }
      break
  }
  // if the date itself isn't well in the clear, then we need to check the days of the week and hours.
  // make sure our days are sorted by day of the week
  const sortedConfigDays = budgetAndSchedule.ActivityConfig.sort((a, b) => _getWeekDayNumber(a.Day) - _getWeekDayNumber(b.Day))
  let startDayOfWeek = startTimeAsDate.getDay()
  if (startYear == '1970') {
    startDayOfWeek = localCurrentDayOfWeek
  }
  let hoursUntilFirstAdActiveHour = 0
  let daysChecked = 0 // don't want an infinite loop
  let hasReachedStartDayOfWeek = false
  let atLeastOneDayActiveWithActiveHours = false // possible for users to have all days active but no active hours
  // always start from current date, but only stop when reaching an active day if after the start date
  for (let i = localCurrentDayOfWeek; i < 7; i = (i + 1) % 7) { // just loops back to 0 after 6
    daysChecked++
    if (daysChecked > 7) {
      break
    }
    if (i == startDayOfWeek) {
      hasReachedStartDayOfWeek = true
    }
    let configDay = sortedConfigDays[i]
    if (hasReachedStartDayOfWeek && configDay.Active && (configDay.ActiveHours && configDay.ActiveHours.length > 0)) {
      atLeastOneDayActiveWithActiveHours = true
      const earliestHour = configDay.ActiveHours.sort((a, b) => a - b)[0]
      if (daysChecked == 1) {
        // if today is the first day checked AND it's an active day, then we only need to add hours
        // if the earliest hour is after the current hour, otherwise we're already supposed to be live
        if (earliestHour > currentLocalHour) {
          hoursUntilFirstAdActiveHour += earliestHour - currentLocalHour
        }
      } else {
        hoursUntilFirstAdActiveHour += earliestHour
      }
      break
    }
    if (i == localCurrentDayOfWeek) {
      // if we're on the current day, then we need to add the remaining hours in the day (not a whole day)
      hoursUntilFirstAdActiveHour += 24 - currentLocalHour
    } else {
      hoursUntilFirstAdActiveHour += 24
    }
  }
  // if there are no active days with active hours, then nothing is going to run anyway, so we can return false
  if (!atLeastOneDayActiveWithActiveHours) {
    return false
  }
  // if basis office hours are still open for at least 3 hours, return true if ads are scheduled to run within 3 hours
  if (basisOfficeHoursRemainingToday >= 3) {
    return hoursUntilFirstAdActiveHour < 3
  } 
  // if basis office hours are closed (or less than 3 hours remaining), then return true if ads are scheduled to 
  // run within 3 hours of the start of the next basis office hours.
  // start with the hours until tomorrow's basis approval hour (10am + 3 hours (to review))
  // then account for weekends
  let hoursUntilNextBasisApprovalHour = 24 - basisCurrentHour + basisOfficeStartHour + 3
  if (basisCurrentDayOfWeek == 5) { // Friday
    hoursUntilNextBasisApprovalHour += 24 * 2
  } else if (basisCurrentDayOfWeek == 6) { // Saturday
    hoursUntilNextBasisApprovalHour += 24
  }
  return hoursUntilFirstAdActiveHour < hoursUntilNextBasisApprovalHour
}
function _getWeekDayNumber(weekDayName) {
  const weekDayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
  return weekDayNames.findIndex(day => day == weekDayName)
}

export default {
    AdsAreScheduledToRunBeforeMinimumApprovalWindow,
}